import { base_colorAction } from 'ext-ui/style/colors'
import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.VendorSelect {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    width: 100%;
  }
`

/*
 * The dropdown panel rows below are rendered by `DropdownMenu` into a MuiPopper
 * PORTAL on <body> — outside `.VendorSelect` entirely. Descendant selectors
 * scoped to the container therefore never match them, so each of these must be
 * applied directly with the `css` prop. `CreditCardDropdownV2` exports its
 * `emptyState` / `loadingOption` styles for exactly this reason.
 */

export const loadingOption = css`
  padding: ${spacing(3)} ${spacing(4)};
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const noMatch = css`
  padding: ${spacing(4)};
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const emptyState = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing(3)};
  padding: ${spacing(4)};
`

export const emptyTitle = css`
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const footerAction = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(2)};
  padding: ${spacing(3)} ${spacing(4)};
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${base_colorAction};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  svg {
    flex-shrink: 0;
  }
`
